module.exports = __webpack_public_path__ + "img/Porto Apartment - 6 of 85.0af9f7c7.jpeg";